import { downloadFile } from '@tma.js/sdk-react';

interface DownloadFileParams {
  file: string | Blob;
  fileName: string;
}

export const downloadFileWithFallback = async ({ file, fileName }: DownloadFileParams) => {
  // Prefer TMA native download when available and we have a URL.
  if (typeof file === 'string' && downloadFile.isAvailable()) {
    try {
      await downloadFile(file, fileName);
      return;
    } catch (error) {
      // Access denied/cancel in Telegram should not trigger browser fallback error noise.
      if ((error as Error).name === 'AccessDeniedError') {
        throw error;
      }
      // For any other SDK issue continue with web fallback below.
    }
  }

  let blob: Blob;
  if (typeof file === 'string') {
    const response = await fetch(file);
    if (!response.ok) {
      throw new Error(`Failed to fetch file: ${response.status}`);
    }
    blob = await response.blob();
  } else {
    blob = file;
  }

  const objectUrl = URL.createObjectURL(blob);
  try {
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
};
